const log = {
    invalid_type: '日志类型无效。',
};
export default Object.freeze(log);
